<template>
    <div v-if="!$apollo.queries.searchFieldValues.loading" class="as-app-search-form">
        <div class="as-app-row tight">
            <!--BRAND-->
            <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Marke</label>
                <div class="input-inner-wrapper">
                    <select v-model="makeId">
                        <option value="null">Alle</option>
                        <option value="74">Volkswagen</option>
                        <option value="64">SEAT</option>
                        <option value="65">Skoda</option>
                        <option value="51802">Cupra</option>
                        <option value="6">Alfa Romeo</option>
                        <option value="28">Fiat</option>
                        <option value="16396">Abarth</option>
                        <option value="38">Jeep</option>
                        <option value="999999">Sonstige Marken</option>
                    </select>
                </div>
            </div>

            <!--Modell-->
            <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Modell</label>
                <div class="input-inner-wrapper">
                    <select v-model="modelId">
                        <option value="null">Alle</option>
                        <template v-if="makeId !== null">
                            <option v-for="option in qualifiedSearchFieldValuesObj.modelSearchValues" :value="option.id" :key="option.id">
                                {{option.name}} ({{option.count}})
                            </option>
                        </template>
                    </select>
                </div>
            </div>

            <!--Typ-->
            <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Typ</label>
                <div class="input-inner-wrapper">
                    <select v-model="bodyTypeEnum">
                        <option value="null">Alle</option>
                        <option v-for="option in bodyTypeInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
            </div>

            <!--Getriebe-->
            <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Getriebe</label>
                <div class="input-inner-wrapper">
                    <select v-model="gearingEnum">
                        <option value="null">Alle</option>
                        <option v-for="option in gearingInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
            </div>

            <!--Kraftstoff-->
            <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Kraftstoff</label>
                <div class="input-inner-wrapper">
                    <select v-model="fuelEnum">
                        <option value="null">Alle</option>
                        <option v-for="option in fuelTypeInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
            </div>

            <!--Schadstoffklasse-->
            <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                <label>Schadstoffklasse</label>
                <div class="input-inner-wrapper">
                    <select v-model="emissionClassEnum">
                        <option value="null">Alle</option>
                        <option v-for="option in emissionClassInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!--Leistung-->
        <div class="as-app-row tight">
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 input-outer-wrapper range-input">
                <label>Leistung</label>
                <!--<span class="label-subline">44kW(59PS) – 206kW(280PS)</span>-->
                <div class="input-inner-wrapper">
                    <select v-model="powerFromInt">
                        <option value="null">von</option>
                        <option v-for="option in powerFromInputValues" :value="option.paramValue"
                                :key="option.paramValue">
                            {{option.paramValue+'kW&nbsp;('+parseInt(option.paramValue*1.34048)+'PS)'}}
                        </option>
                    </select>
                </div>
                <div class="input-inner-wrapper">
                    <select v-model="powerToInt">
                        <option value="null">bis</option>
                        <option v-for="option in powerToInputValues" :value="option.paramValue"
                                :key="option.paramValue">
                            {{option.paramValue+'kW&nbsp;('+parseInt(option.paramValue*1.34048)+'PS)'}}
                        </option>
                    </select>
                </div>
            </div>

            <!--Erstzulassung-->
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 input-outer-wrapper range-input">
                <label>Erstzulassung</label>
                <div class="input-inner-wrapper">
                    <select v-model="firstRegistrationFromInt">
                        <option value="null">von</option>
                        <option v-for="option in firstRegistrationFromInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.paramValue}}
                        </option>
                    </select>
                </div>
                <div class="input-inner-wrapper">
                    <select v-model="firstRegistrationToInt">
                        <option value="null">bis</option>
                        <option v-for="option in firstRegistrationToInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.paramValue}}
                        </option>
                    </select>
                </div>
            </div>

            <!--Kilometerstand-->
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 input-outer-wrapper range-input">
                <label>Kilometerstand</label>
                <div class="input-inner-wrapper">
                    <select v-model="mileageFromInt">
                        <option value="null">von</option>
                        <option v-for="option in mileageFromInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}} km
                        </option>
                    </select>
                </div>
                <div class="input-inner-wrapper">
                    <select v-model="mileageToInt">
                        <option value="null">bis</option>
                        <option v-for="option in mileageToInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}} km
                        </option>
                    </select>
                </div>
            </div>

            <!--Preis-->
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 input-outer-wrapper range-input">
                <label>Preis</label>
                <div class="input-inner-wrapper">
                    <select v-model="priceFromInt">
                        <option value="null">von</option>
                        <option v-for="option in priceFromInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
                <div class="input-inner-wrapper">
                    <select v-model="priceToInt">
                        <option value="null">bis</option>
                        <option v-for="option in priceToInputValues" :value="option.paramValue"
                                :key="option.paramValue">{{option.label.de_DE}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="!showMoreInputOptions" class="btn-ah-wrapper btn-ah-clean-wrapper text-center">
            <button class="btn-ah btn-ah-clean has-fa" @click="showMoreInputOptions = true">mehr Suchoptionen <font-awesome-icon :icon="['fas', 'angle-double-down']" /></button>
        </div>
        <div class="more-input-options" :class="showMoreInputOptions ? 'show-more' : ''">
            <!--Zustand-->
            <div class="as-app-row tight">
                <div class="as-app-col as-app-col-12">
                    <h3>Zustand</h3>
                </div>
                <div v-for="option in offerTypeInputValues" :key="option.paramValue"
                     class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label :for="option.paramValue">{{option.label.de_DE}}</label>
                    <div class="input-inner-wrapper">
                        <input type="checkbox" name="offerType" :value="option.paramValue" v-model="offerTypeEnum"
                               :id="option.paramValue"/>
                    </div>
                </div>
            </div>

            <!--Farbe & Polsterart-->
            <div class="as-app-row tight">
                <div class="as-app-col as-app-col-12">
                    <h3>Farbe & Polsterart</h3>
                </div>
                <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                    <label>Farbe</label>
                    <div class="input-inner-wrapper">
                        <select v-model="bodyColorEnum">
                            <option value="null">Alle</option>
                            <option v-for="option in bodyColorInputValues" :value="option.paramValue"
                                    :key="option.paramValue">{{option.label.de_DE}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="as-app-col as-app-col-6 as-app-col-sm-4 input-outer-wrapper select-input">
                    <label>Polsterart</label>
                    <div class="input-inner-wrapper">
                        <select v-model="upholsteryEnum">
                            <option value="null">Alle</option>
                            <option v-for="option in upholsteryInputValues" :value="option.paramValue"
                                    :key="option.paramValue">{{option.label.de_DE}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="as-app-row tight">
                <div class="as-app-col as-app-col-12">
                    <h3>Ausstattung</h3>
                </div>
                <!--      <div v-for="option in equipmentInputValues" :key="option.paramValue" class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">-->
                <!--        <label :for="option.paramValue">{{option.label.de_DE}}</label>-->
                <!--        <div class="input-inner-wrapper">-->
                <!--          <input type="checkbox" name="equipment" :value="option.paramValue" v-model="equipmentEnum" :id="option.paramValue"/>-->
                <!--        </div>-->
                <!--      </div>-->
                <!--          Komfort-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Komfort &amp;
                    Innenausstattung</h4></div>

                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="LumbarSupport">Lordosenstütze</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="LumbarSupport" value="LumbarSupport"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Sunroof">Schiebedach</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="Sunroof" value="Sunroof"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Armrest">Armlehne</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="Armrest" value="Armrest"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="ElectricallyHeatedWindshield">Beheizbare Frontscheibe</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="ElectricallyHeatedWindshield"
                                                            value="ElectricallyHeatedWindshield"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AirConditioning">Klimaanlage</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="AirConditioning" value="AirConditioning"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AutomaticClimateControl">Klimaautomatik</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="AutomaticClimateControl" value="AutomaticClimateControl">
                    </div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="PanoramaRoof">Panoramadach</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="PanoramaRoof" value="PanoramaRoof"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AuxHeating">Standheizung</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="AuxHeating" value="AuxHeating"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="StartStopSystem">Start/Stop-Automatik</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="StartStopSystem" value="StartStopSystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="HeatedSteeringWheel">Beheizbares Lenkrad</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="HeatedSteeringWheel" value="HeatedSteeringWheel"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="HillHolder">Berganfahrassistent</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="HillHolder" value="HillHolder"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="ElectricallyAdjustableSeats">Elektrische Sitze</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="ElectricallyAdjustableSeats"
                                                            value="ElectricallyAdjustableSeats"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="ElectricalSideMirrors">Elektrische Seitenspiegel</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="ElectricalSideMirrors" value="ElectricalSideMirrors"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="ElectricTailgate">Elektrische Heckklappe</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="ElectricTailgate" value="ElectricTailgate"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="LeatherSteeringWheel">Lederlenkrad</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="LeatherSteeringWheel" value="LeatherSteeringWheel"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="MassageSeats">Massagesitze</label>
                    <div class="input-inner-wrapper"><input type="checkbox" name="equipment" v-model="equipmentEnum"
                                                            id="MassageSeats" value="MassageSeats"></div>
                </div>


                <!--          Sicherheit-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Komfort &amp;
                    Sicherheit</h4></div>


                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Abs">ABS</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Abs" value="Abs">
                    </div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="DriverSideAirbag">Fahrerairbag</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="DriverSideAirbag"
                                                            value="DriverSideAirbag"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="PassengerSideAirbag">Beifahrerairbag</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="PassengerSideAirbag"
                                                            value="PassengerSideAirbag"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AlarmSystem">Alarmanlage</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="AlarmSystem"
                                                            value="AlarmSystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Immobilizer">Wegfahrsperre</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Immobilizer"
                                                            value="Immobilizer"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SideAirbag">Seitenairbag</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SideAirbag"
                                                            value="SideAirbag"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SeatHeating">Sitzheizung</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SeatHeating"
                                                            value="SeatHeating"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="CruiseControl">Tempomat</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="CruiseControl"
                                                            value="CruiseControl"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="XenonHeadlights">Xenonscheinwerfer</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="XenonHeadlights"
                                                            value="XenonHeadlights"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="ElectronicStabilityControl">ESP</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="ElectronicStabilityControl"
                                                            value="ElectronicStabilityControl"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="FogLights">Nebelscheinwerfer</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="FogLights"
                                                            value="FogLights"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AdaptiveHeadlights">Kurvenlicht</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="AdaptiveHeadlights"
                                                            value="AdaptiveHeadlights"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AdaptiveCruiseControl">Abstandstempomat</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="AdaptiveCruiseControl"
                                                            value="AdaptiveCruiseControl"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Isofix">Isofix</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Isofix"
                                                            value="Isofix">
                    </div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="LightSensor">Lichtsensor</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="LightSensor"
                                                            value="LightSensor"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="RainSensor">Regensensor</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="RainSensor"
                                                            value="RainSensor"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SystemSensorsFront">Einparkhilfe Sensoren vorne</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SystemSensorsFront"
                                                            value="SystemSensorsFront"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SystemSensorsRear">Einparkhilfe Sensoren hinten</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SystemSensorsRear"
                                                            value="SystemSensorsRear"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SystemCamera">Einparkhilfe Kamera</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SystemCamera"
                                                            value="SystemCamera"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SystemSelfSteering">Einparkhilfe selbstlenkendes System</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SystemSelfSteering"
                                                            value="SystemSelfSteering"></div>
                </div>

                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="LaneDepartureWarning">Spurhalteassistent</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="LaneDepartureWarning"
                                                            value="LaneDepartureWarning"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="BlindSpotMonitor">Totwinkel-Assistent</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="BlindSpotMonitor"
                                                            value="BlindSpotMonitor"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="TrafficSignRecognition">Verkehrszeichenerkennung</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="TrafficSignRecognition"
                                                            value="TrafficSignRecognition"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="TractionControl">Traktionskontrolle</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="TractionControl"
                                                            value="TractionControl"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="DriverDrowsinessDetection">Müdigkeitswarnsystem</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="DriverDrowsinessDetection"
                                                            value="DriverDrowsinessDetection"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="NightViewAssist">Nachtsicht-Assistent</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="NightViewAssist"
                                                            value="NightViewAssist"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="EmergencyBrakeAssistant">Notbremsassistent</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="EmergencyBrakeAssistant"
                                                            value="EmergencyBrakeAssistant"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="EmergencySystem">Notrufsystem</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="EmergencySystem"
                                                            value="EmergencySystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="TirePressureMonitoringSystem">Reifendruckkontrollsystem</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="TirePressureMonitoringSystem"
                                                            value="TirePressureMonitoringSystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="LedHeadlights">LED-Scheinwerfer</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="LedHeadlights"
                                                            value="LedHeadlights"></div>
                </div>


                <!--          Media & Navigation-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Media & Navigation</h4></div>


                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Radio">Radio</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Radio"
                                                            value="Radio">
                    </div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="NavigationSystem">Navigationssystem</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="NavigationSystem"
                                                            value="NavigationSystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="OnBoardComputer">Bordcomputer</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="OnBoardComputer"
                                                            value="OnBoardComputer"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Bluetooth">Bluetooth</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Bluetooth"
                                                            value="Bluetooth"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="HeadsUpDisplay">Head-up display</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="HeadsUpDisplay"
                                                            value="HeadsUpDisplay"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="HandsFreeEquipment">Freisprecheinrichtung</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="HandsFreeEquipment"
                                                            value="HandsFreeEquipment"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="CdPlayer">CD</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="CdPlayer"
                                                            value="CdPlayer"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Mp3">MP3</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Mp3" value="Mp3">
                    </div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="MultiFunctionSteeringWheel">Multifunktionslenkrad</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum"
                                                            id="MultiFunctionSteeringWheel"
                                                            value="MultiFunctionSteeringWheel"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="DigitalRadio">DAB-Radio</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="DigitalRadio"
                                                            value="DigitalRadio"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SoundSystem">Soundsystem</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SoundSystem"
                                                            value="SoundSystem"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="VoiceControl">Sprachsteuerung</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="VoiceControl"
                                                            value="VoiceControl"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="TouchScreen">Touchscreen</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="TouchScreen"
                                                            value="TouchScreen"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Television">TV</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Television"
                                                            value="Television"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="Usb">USB</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="Usb" value="Usb">
                    </div>
                </div>


                <!--          Antrieb-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Antrieb</h4></div>

                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="_4wd">Allrad</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="_4wd" value="_4wd">
                    </div>
                </div>


                <!--          Exterieur-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Exterieur</h4></div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="AlloyWheels">Alufelgen</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="AlloyWheels"
                                                            value="AlloyWheels"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="TrailerHitch">Anhängerkupplung</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="TrailerHitch"
                                                            value="TrailerHitch"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="RoofRack">Dachreling</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="RoofRack"
                                                            value="RoofRack"></div>
                </div>


                <!--          Weiteres-->
                <div class="as-app-col as-app-col-12"><h4 data-v-51efc6bc="">Weiteres</h4></div>

                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SportSuspension">Sportfahrwerk</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SportSuspension"
                                                            value="SportSuspension"></div>
                </div>
                <div class="as-app-col as-app-col-12 as-app-col-sm-4 input-outer-wrapper checkbox-input">
                    <label for="SportSeats">Sportsitze</label>
                    <div class="input-inner-wrapper"><input type="checkbox"
                                                            name="equipment" v-model="equipmentEnum" id="SportSeats"
                                                            value="SportSeats"></div>
                </div>
            </div>
        </div>
        <div class="btn-ah-wrapper text-center btn-search-wrapper">
            <!--      <router-link to="/hello/fahrzeuge" class="btn-ah btn-search">{{resultsCount}} Autos anzeigen</router-link>-->
            <a :href="$store.state.marketPath" class="btn-ah btn-search has-fa">{{resultsCount}} Autos
                anzeigen <font-awesome-icon :icon="['fas', 'arrow-alt-circle-right']" /></a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: 'SearchForm',
        props: {
            msg: String
        },
        data() {
            return {
                makeIdChanged: false,
                modelInputValues: [],
                search: '',
                showMoreInputOptions: false,
                searchFieldValues: { //represents possible values for the fields, access via computed method
                    modelId: '',
                    bodyType: '',
                    fuelType: '',
                    gearing: '',
                    emissionClass: '',
                    powerFrom: '',
                    powerTo: '',
                    firstRegistrationFrom: '',
                    firstRegistrationTo: '',
                    mileageFrom: '',
                    mileageTo: '',
                    priceFrom: '',
                    priceTo: '',
                    offerType: [],
                    bodyColor: '',
                    upholstery: '',
                    equipment: [],
                },
                qualifiedSearchFieldValuesObj: {
                    modelSearchValues: []
                }
            }
        },
        methods: {
            getFuelsEnumArray() {
                let fuelsEnumArray = []
                this.fuelTypeInputValues.forEach(function (fuelsObject) {
                    fuelsEnumArray.push(fuelsObject.paramValue)
                });
                return fuelsEnumArray
            },
            sortByProperty(arr, sort, property) {
                // console.log(property);
                arr.sort(this.compare(property))
                if (sort === 'desc') arr.reverse()
                // console.log(arr);
                return arr
            },
            buildQualifiedSearchFieldValuesObj(arr){
                // console.log(arr);
                let modelObject
                let modelObjectArray = []


                if (arr.length > 0) {
                    let currentMakeName
                    let currentModel
                    let currentModelName
                    modelObject =  arr.reduce((result, current) => {
                        currentMakeName = this.$R.pathOr('-',['details','vehicle','classification','make','formatted'], current).toString()
                        currentModel = this.$R.pathOr('-',['details','vehicle','classification','model','raw'], current).toString()
                        currentModelName = this.$R.pathOr('-',['details','vehicle','classification','model','formatted'], current)
                        if(currentModelName !== '-'){
                            if (!result[currentModel]) {
                                result[currentModel] = {};
                                result[currentModel].id = currentModel;
                                result[currentModel].name = this.makeId === 999999 ? currentMakeName + ' ' + currentModelName : currentModelName;
                                result[currentModel].count = 1;
                            } else {
                                result[currentModel].count += 1;
                            }
                        }
                        return result;
                    }, {})
                } else {
                    return []
                }

                modelObjectArray = Object.values(modelObject)

                // if (arr.length > 0) {
                //     modelObjectArrayCleaned = arr.filter((arritem, index, self) =>
                //         index === self.findIndex((f) => (
                //             this.$R.pathOr('-',['details','vehicle','classification','model','raw'], f) === this.$R.pathOr('-',['details','vehicle','classification','model','raw'], arritem) && this.$R.pathOr('-',['details','vehicle','classification','model','formatted'], f) === this.$R.pathOr('-',['details','vehicle','classification','model','formatted'], arritem)
                //         ))
                //         // if(self[index].quantity !== 'undefined'){
                //         //     self[index].quantity++
                //         // } else {
                //         //     self[index].quantity = 1
                //         // }
                //     )
                // }




                // console.log('Results');
                // console.log(modelObjectArrayCleaned);
                // modelObjectArrayCleaned.forEach(function (modelObject) {
                //     modelObjectArray.push(modelObject.details.vehicle.classification.model)
                // });
                // console.log(modelObjectArray);
                this.sortByProperty(modelObjectArray,'asc','name')
                // console.log(modelObjectArray);
                return {
                    modelSearchValues: modelObjectArray
                }
            },
            cleanParamValueObjects(arr, sort, lowest, highest) {
                // Cleans duplicate entries of the taxonomy request and as well removes object with paramValue 'Unknown' or empty label.
                let tempArray
                if (arr.length > 0) {
                    tempArray = arr.filter((arritem, index, self) =>
                        index === self.findIndex((f) => (
                            (f.paramValue === arritem.paramValue && f.label.de_DE === arritem.label.de_DE) || arritem.paramValue === 'Unknown' || arritem.paramValue === null || arritem.paramValue === 'null' || arritem.label === ''
                        ))
                    )
                }

                if (tempArray.length > 0) {
                    if (typeof lowest !== 'undefined') {
                        tempArray = tempArray.filter((arritem) => arritem.paramValue >= lowest)
                    }
                    if (typeof highest !== 'undefined') {
                        tempArray = tempArray.filter((arritem) => arritem.paramValue <= highest)
                    }
                }


                if (sort === 'asc' || sort === 'desc') {
                    tempArray.sort(this.compare('paramValue'));
                    if (sort === 'desc') tempArray.reverse()
                } else if (typeof sort !== 'undefined') {
                    console.log('Wrong sortdirection. \'asc\' or \'desc\'');
                }
                return tempArray
            },
            compare(key) {
                //Wrapped function to pass third argument to compare
                return function(a,b) {
                    // console.log('a ', a, 'b: ', b, 'key: ', key);
                    if (a[key] < b[key]) {
                        return -1;
                    }
                    if (a[key] > b[key]) {
                        return 1;
                    }
                    return 0;
                }
            },
            correctParamValueSpelling(arr, correctionsArr) {
                arr.forEach(function (arrObject) {
                    // console.log(arrObject)
                    correctionsArr.forEach(function (correction) {
                        // console.log(correction)
                        arrObject.paramValue = arrObject.paramValue.replace(correction.subStr, correction.newSubStr)
                        // console.log(arrObject.paramValue)
                    })
                })
                return arr
            },
            filterOptionsAgainst(arr, item, direction) {
                if (arr === '' || arr === null) return null //If no inputvalues are available which happens on mount.
                // if(item === null) return arr //If oponent is not set/null return full array.
                let sliceIndex = -1
                // console.log(typeof arr, arr)
                arr.forEach(function (searchObj, index) {
                    // console.log(searchObj.paramValue, item);
                    if (searchObj.paramValue === item) sliceIndex = index
                })
                // console.log(sliceIndex);
                if (sliceIndex >= 0) {
                    // console.log(arr.slice(sliceIndex+1,arr.length));
                    if (direction === 'down') {
                        if (sliceIndex === arr.length - 1) return null
                        return arr.slice(sliceIndex + 1, arr.length - 1)
                    } else if (direction === 'up') {
                        return arr.slice(0, sliceIndex)
                    } else {
                        console.log('Wrong value for direction. Needs to be \'up\' or \'down\'');
                    }
                }
                return arr
            },
            getQualifiedSearchPageSize() {
                if(this.makeId === null){
                    return 1
                }else if (this.makeId === 74){
                    return 300 //VOlkswagen
                } else if (this.makeId === 64){
                    return 250 //SEAT
                } else if(this.makeId === 28){
                    return 200 //Fiat
                } else if(this.makeId === 9 || this.makeId === 13 || this.makeId === 16360 || this.makeId === 29 || this.makeId === 31 || this.makeId === 39 || this.makeId === 46 || this.makeId === 47 || this.makeId === 16338 || this.makeId === 54 || this.makeId === 55 || this.makeId === 57 || this.makeId === 70 || this.makeId === 73){
                    return 10 //Fiat
                } else {
                 return 150   //OTHER:Jeep, Alfa Romeo, Abarth etc.
                }
            }
        },
        computed: {
            resultsCount: {
                get() {
                    return this.$store.state.resultsCountProxy
                },
                set(val) {
                    this.$store.commit('updateResultsCount', val)
                }
            },

            ////////////////////////////
            // Possible inputs values //
            ////////////////////////////

            modelIdInputValues: {
                get() {
                    return this.searchFieldValues.modelId
                    // return this.qualifiedSearchFieldValuesObj.modelSearchValues
                },
                set(val) {
                    this.searchFieldValues.modelId = val
                    // this.qualifiedSearchFieldValuesObj.modelSearchValues = val
                }
            },
            fuelTypeInputValues: {
                get() {
                    return this.searchFieldValues.fuelType
                },
                set(val) {
                    this.searchFieldValues.fuelType = val
                }
            },
            bodyTypeInputValues: {
                get() {
                    return this.searchFieldValues.bodyType
                },
                set(val) {
                    this.searchFieldValues.bodyType = val
                }
            },
            gearingInputValues: {
                get() {
                    return this.searchFieldValues.gearing
                },
                set(val) {
                    this.searchFieldValues.gearing = val
                }
            },
            emissionClassInputValues: {
                get() {
                    return this.searchFieldValues.emissionClass
                },
                set(val) {
                    this.searchFieldValues.emissionClass = val
                }
            },
            powerFromInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.powerFrom, this.powerToInt, 'up')
                },
                set(val) {
                    this.searchFieldValues.powerFrom = val
                }
            },
            powerToInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.powerTo, this.powerFromInt, 'down')
                },
                set(val) {
                    this.searchFieldValues.powerTo = val
                }
            },
            firstRegistrationFromInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.firstRegistrationFrom, this.firstRegistrationToInt, 'down')
                },
                set(val) {
                    this.searchFieldValues.firstRegistrationFrom = val
                }
            },
            firstRegistrationToInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.firstRegistrationTo, this.firstRegistrationFromInt, 'up')
                },
                set(val) {
                    this.searchFieldValues.firstRegistrationTo = val
                }
            },
            mileageFromInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.mileageFrom, this.mileageToInt, 'up')
                },
                set(val) {
                    this.searchFieldValues.mileageFrom = val
                }
            },
            mileageToInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.mileageTo, this.mileageFromInt, 'down')
                },
                set(val) {
                    this.searchFieldValues.mileageTo = val
                }
            },
            priceFromInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.priceFrom, this.priceToInt, 'up')
                },
                set(val) {
                    this.searchFieldValues.priceFrom = val
                }
            },
            priceToInputValues: {
                get() {
                    return this.filterOptionsAgainst(this.searchFieldValues.priceTo, this.priceFromInt, 'down')
                },
                set(val) {
                    this.searchFieldValues.priceTo = val
                }
            },
            offerTypeInputValues: {
                get() {
                    return this.searchFieldValues.offerType
                },
                set(val) {
                    this.searchFieldValues.offerType = val
                }
            },
            bodyColorInputValues: {
                get() {
                    return this.searchFieldValues.bodyColor
                },
                set(val) {
                    this.searchFieldValues.bodyColor = val
                }
            },
            upholsteryInputValues: {
                get() {
                    return this.searchFieldValues.upholstery
                },
                set(val) {
                    this.searchFieldValues.upholstery = val
                }
            },
            equipmentInputValues: {
                get() {
                    return this.searchFieldValues.equipment
                },
                set(val) {
                    this.searchFieldValues.equipment = val
                }
            },


            //////////////////////////
            // Actual inputs values //
            //////////////////////////

            makeId: {
                get() {
                    return this.$store.state.searchParams.makeIdProxy
                    // return this.makeIdProxy
                },
                set(val) {
                    if (this.$store.state.searchParams.makeIdProxy !== null && this.$store.state.searchParams.makeIdProxy === parseInt(val)) {
                        //if make is not all and the make didn't change.
                        this.makeIdChanged = false
                    } else {
                        this.makeIdChanged = true
                        this.$store.commit('updateSearchParams', {modelIdProxy: null}) //Build object that will be merged into state.searchParams
                    }
                    // this.$store.commit('updateMakeId', val==='null' ? null : parseInt(val))
                    this.$store.commit('updateSearchParams', {makeIdProxy: val === 'null' ? null : parseInt(val)}) //Build object that will be merged into state.searchParams
                    // this.makeIdProxy = val==='null' ? null : parseInt(val)
                }
            },
            modelId: {
                get() {
                    return this.$store.state.searchParams.modelIdProxy
                },
                set(val) {
                    // Empty the models options as make is null.
                    this.$store.commit('updateSearchParams', {modelIdProxy: val === 'null' ? null : parseInt(val)}) //Build object that will be merged into state.searchParams
                    // this.$store.state.searchParams.modelIdProxy = val==='null' ? null : parseInt(val)
                }
            },
            bodyTypeEnum: {
                get() {
                    return this.$store.state.searchParams.bodyTypeEnumProxy
                },
                set(val) {
                    // Empty the models options as make is null.
                    this.$store.commit('updateSearchParams', {bodyTypeEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                    // this.bodyTypeEnumProxy = val==='null' ? null : val
                }
            },
            fuelEnum: {
                get() {
                    return this.$store.state.searchParams.fuelEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {fuelEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            gearingEnum: {
                get() {
                    return this.$store.state.searchParams.gearingEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {gearingEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            emissionClassEnum: {
                get() {
                    return this.$store.state.searchParams.emissionClassEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {emissionClassEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            powerFromInt: {
                get() {
                    return this.$store.state.searchParams.powerFromIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {powerFromIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            powerToInt: {
                get() {
                    return this.$store.state.searchParams.powerToIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {powerToIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            firstRegistrationFromInt: {
                get() {
                    return this.$store.state.searchParams.firstRegistrationFromIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {firstRegistrationFromIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            firstRegistrationToInt: {
                get() {
                    return this.$store.state.searchParams.firstRegistrationToIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {firstRegistrationToIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            mileageFromInt: {
                get() {
                    return this.$store.state.searchParams.mileageFromIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {mileageFromIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            mileageToInt: {
                get() {
                    return this.$store.state.searchParams.mileageToIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {mileageToIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            priceFromInt: {
                get() {
                    return this.$store.state.searchParams.priceFromIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {priceFromIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            priceToInt: {
                get() {
                    return this.$store.state.searchParams.priceToIntProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {priceToIntProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            offerTypeEnum: {
                get() {
                    return this.$store.state.searchParams.offerTypeEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {offerTypeEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            bodyColorEnum: {
                get() {
                    return this.$store.state.searchParams.bodyColorEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {bodyColorEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            upholsteryEnum: {
                get() {
                    return this.$store.state.searchParams.upholsteryEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {upholsteryEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
            equipmentEnum: {
                get() {
                    return this.$store.state.searchParams.equipmentEnumProxy
                },
                set(val) {
                    this.$store.commit('updateSearchParams', {equipmentEnumProxy: val === 'null' ? null : val}) //Build object that will be merged into state.searchParams
                }
            },
        },
        apollo: {
            ///////////////////////////////////////
            // Get Results Count based in Inputs //
            ///////////////////////////////////////

            // resultsCount: {
            //     query: require('../graphql/SearchResults.gql'),
            //     errorPolicy: 'all',
            //     manual: true,
            //     variables() {
            //         // Use vue reactive properties here
            //         return {
            //             withListings: false,
            //             makeId: this.$store.state.searchParams.makeIdProxy,
            //             modelId: this.$store.state.searchParams.modelIdProxy,
            //             bodyTypeEnum: this.$store.state.searchParams.bodyTypeEnumProxy === null ? [] : this.$store.state.searchParams.bodyTypeEnumProxy,
            //             gearingEnum: this.$store.state.searchParams.gearingEnumProxy === null ? [] : this.$store.state.searchParams.gearingEnumProxy,
            //             fuelEnum: this.$store.state.searchParams.fuelEnumProxy === null ? [] : this.$store.state.searchParams.fuelEnumProxy, //if errors occur make sure the full enumArray is provided instead of [] by changing it to this.getFuelsEnumArray()
            //             emissionClassEnum: this.$store.state.searchParams.emissionClassEnumProxy === null ? null : this.$store.state.searchParams.emissionClassEnumProxy,
            //             powerFromInt: this.$store.state.searchParams.powerFromIntProxy,
            //             powerToInt: this.$store.state.searchParams.powerToIntProxy,
            //             firstRegistrationFromInt: this.$store.state.searchParams.firstRegistrationFromIntProxy,
            //             firstRegistrationToInt: this.$store.state.searchParams.firstRegistrationToIntProxy,
            //             mileageFromInt: this.$store.state.searchParams.mileageFromIntProxy,
            //             mileageToInt: this.$store.state.searchParams.mileageToIntProxy,
            //             priceFromInt: this.$store.state.searchParams.priceFromIntProxy,
            //             priceToInt: this.$store.state.searchParams.priceToIntProxy,
            //             offerTypeEnum: this.$store.state.searchParams.offerTypeEnumProxy,
            //             bodyColorEnum: this.$store.state.searchParams.bodyColorEnumProxy,
            //             upholsteryEnum: this.$store.state.searchParams.upholsteryEnumProxy,
            //             equipmentEnum: this.$store.state.searchParams.equipmentEnumProxy,
            //             sortByEnum: this.$store.state.searchParams.sortObjectProxy.sortBy,
            //             sortOrderEnum: this.$store.state.searchParams.sortObjectProxy.sortOrder,
            //         }
            //     },
            //     error(error) {
            //         console.log({error})
            //     },
            //     result(data) {
            //         if (typeof data.data !== 'undefined' && !data.loading) {
            //             this.resultsCount = data.data.search.listings.metadata.totalItems
            //         }
            //     }
            // },

            ///////////////////////////////////////
            // Get possible InputValues from API //
            ///////////////////////////////////////

            searchFieldValues: {
                query: require('../graphql/SearchFieldValues.gql'),
                errorPolicy: 'all',
                fetchPolicy: 'no-cache',
                context: {
                     headers: {
                         "X-Statistics": "true"
                     }
                },
                manual: true,
                variables() {
                    // Use vue reactive properties here
                    return {
                        // makeId: this.makeId === null ? 0 : this.makeId, //Send 0 in order to have response as small as possible (no models send back) null would send every available model of every make.
                        makeId: this.$store.state.searchParams.makeIdProxy,
                        modelId: this.$store.state.searchParams.modelIdProxy,
                        includeModels: this.$store.state.searchParams.makeIdProxy === null ? false : true,
                        bodyTypeEnum: this.$store.state.searchParams.bodyTypeEnumProxy === null ? [] : this.$store.state.searchParams.bodyTypeEnumProxy,
                        gearingEnum: this.$store.state.searchParams.gearingEnumProxy === null ? [] : this.$store.state.searchParams.gearingEnumProxy,
                        fuelEnum: this.$store.state.searchParams.fuelEnumProxy === null ? [] : this.$store.state.searchParams.fuelEnumProxy, //if errors occur make sure the full enumArray is provided instead of [] by changing it to this.getFuelsEnumArray()
                        emissionClassEnum: this.$store.state.searchParams.emissionClassEnumProxy === null ? null : this.$store.state.searchParams.emissionClassEnumProxy,
                        powerFromInt: this.$store.state.searchParams.powerFromIntProxy,
                        powerToInt: this.$store.state.searchParams.powerToIntProxy,
                        firstRegistrationFromInt: this.$store.state.searchParams.firstRegistrationFromIntProxy,
                        firstRegistrationToInt: this.$store.state.searchParams.firstRegistrationToIntProxy,
                        mileageFromInt: this.$store.state.searchParams.mileageFromIntProxy,
                        mileageToInt: this.$store.state.searchParams.mileageToIntProxy,
                        priceFromInt: this.$store.state.searchParams.priceFromIntProxy,
                        priceToInt: this.$store.state.searchParams.priceToIntProxy,
                        offerTypeEnum: this.$store.state.searchParams.offerTypeEnumProxy,
                        bodyColorEnum: this.$store.state.searchParams.bodyColorEnumProxy,
                        upholsteryEnum: this.$store.state.searchParams.upholsteryEnumProxy,
                        equipmentEnum: this.$store.state.searchParams.equipmentEnumProxy,
                        sortByEnum: this.$store.state.searchParams.sortObjectProxy.sortBy,
                        sortOrderEnum: this.$store.state.searchParams.sortObjectProxy.sortOrder,
                        aMakeIdOne: this.$store.state.searchParams.makeIdProxy === 999999 ? 9 : null, // Audi 999999 steht für sonstige Marken und macht dann einen Query auf mehrere Marken, da man für make kein Array übergeben kann.
                        aMakeIdTwo: this.$store.state.searchParams.makeIdProxy === 999999 ? 13 : null, //BMW
                        aMakeIdThree: this.$store.state.searchParams.makeIdProxy === 999999 ? 16360 : null, //Dacia
                        aMakeIdFour: this.$store.state.searchParams.makeIdProxy === 999999 ? 29 : null, // Ford
                        aMakeIdFive: this.$store.state.searchParams.makeIdProxy === 999999 ? 31 : null, // Honda
                        aMakeIdSix: this.$store.state.searchParams.makeIdProxy === 999999 ? 39 : null, // Kia
                        aMakeIdSeven: this.$store.state.searchParams.makeIdProxy === 999999 ? 46 : null, // Mazda
                        aMakeIdEight: this.$store.state.searchParams.makeIdProxy === 999999 ? 47 : null, // Mercedes
                        aMakeIdNine: this.$store.state.searchParams.makeIdProxy === 999999 ? 16338 : null, // Mini
                        aMakeIdTen: this.$store.state.searchParams.makeIdProxy === 999999 ? 54 : null, // Opel
                        aMakeIdEleven: this.$store.state.searchParams.makeIdProxy === 999999 ? 55 : null, // Peugeot
                        aMakeIdTwelve: this.$store.state.searchParams.makeIdProxy === 999999 ? 57 : null, // Porsche
                        aMakeIdThirteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 70 : null, // Toyota
                        aMakeIdFourteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 73 : null // Volvo
                    }
                },
                error(error) {
                    // console.log('Car of the week might not be available anymore.')
                    // console.log({error})
                    if(parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    // console.log(data.loading);
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        // this.modelInputValues = this.sortByProperty(data.data.searchFieldValues.filters.model.values,'asc', 'name')
                        // console.log(data)
                        // console.log(this.$store.state.searchParams.makeIdProxy)
                        this.resultsCount = data.data.totalItems.listings.metadata.totalItems
                        // Früher würde durch einen query mit dem Wert 0 für die Variable make die Anzahl aller Autos zurückgegeben. In der aktuellen Apiversion kommt als Anzahl 0 zurück. Deshalb separate Anfrage ohne make-Variable, um Anzahl zu bekommen, wenn keine Marke ausgewählt wurde
                        // this.resultsCount = this.$store.state.searchParams.makeIdProxy === null ? data.data.totalItemsAllMakes.listings.metadata.totalItems : data.data.totalItems.listings.metadata.totalItems
                        // this.qualifiedSearchFieldValuesObj = this.buildQualifiedSearchFieldValuesObj(data.data.qualifiedSearchFieldValues.listings.listings)

                        // console.log(this.modelInputValues);
                        this.fuelTypeInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.fuelType.values)  // Remove duplicate entries


                        let tempBodyTypesArray = this.cleanParamValueObjects(data.data.searchFieldValues.filters.bodyType.values)// Remove duplicate entries
                        //Correct false paramValues for bodyType
                        let objIndex = tempBodyTypesArray.findIndex((obj => obj.paramValue === 'Offroad'));
                        tempBodyTypesArray[objIndex].paramValue = "OffRoad"
                        this.bodyTypeInputValues = tempBodyTypesArray

                        this.gearingInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.gearing.values)  // Remove duplicate entries
                        this.emissionClassInputValues = this.correctParamValueSpelling(this.cleanParamValueObjects(data.data.searchFieldValues.filters.emissionClass.values), [{
                            subStr: 'EURO',
                            newSubStr: 'Euro'
                        }, {subStr: 'TEMP', newSubStr: 'Temp'}])  // Remove duplicate entries

                        this.powerFromInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.powerFrom.values, 'asc', 40)  // Remove duplicate entries
                        this.powerToInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.powerTo.values, 'asc', 40)  // Remove duplicate entries

                        this.firstRegistrationFromInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.firstRegistrationFrom.values, 'desc', 2010)  // Remove duplicate entries
                        this.firstRegistrationToInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.firstRegistrationTo.values, 'desc', 2010)  // Remove duplicate entries

                        this.mileageFromInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.mileageFrom.values, 'asc')  // Remove duplicate entries
                        this.mileageToInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.mileageTo.values, 'asc')  // Remove duplicate entries

                        this.priceFromInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.priceFrom.values, 'asc', 1000)  // Remove duplicate entries
                        this.priceToInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.priceTo.values, 'asc', 1000)  // Remove duplicate entries

                        this.offerTypeInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.offer.values)  // Remove duplicate entries

                        this.bodyColorInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.bodyColor.values)  // Remove duplicate entries

                        this.upholsteryInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.upholstery.values)  // Remove duplicate entries

                        this.equipmentInputValues = this.cleanParamValueObjects(data.data.searchFieldValues.filters.equipment.values)  // Remove duplicate entries
                    }
                }
            },

            ///////////////////////////////////////
            // Get InputValues and Quantity based on SearchFieldValues from API //
            ///////////////////////////////////////

            qualifiedSearchFieldValues: {
                query: require('../graphql/QualifiedSearchFieldValues.gql'),
                skip() {
                    return this.makeId === null ? true : false;
                },
                errorPolicy: 'all',
                fetchPolicy: 'no-cache',
                context: {
                    headers: {
                        "X-Statistics": "true"
                    }
                },
                manual: true,
                variables() {
                    // Use vue reactive properties here
                    return {
                        makeId: this.makeId === null ? null : this.makeId, //Send 0 in order to have response as small as possible (no models send back) null would send every available model of every make.
                        size: 399, // this.getQualifiedSearchPageSize(), 400 is the limit of the API.
                        // modelId: this.modelId === null ? null : this.modelId, //Send 0 in order to have response as small as possible (no models send back) null would send every available model of every make.
                        aMakeIdOne: this.$store.state.searchParams.makeIdProxy === 999999 ? 9 : null, // Audi
                        aMakeIdTwo: this.$store.state.searchParams.makeIdProxy === 999999 ? 13 : null, //BMW
                        aMakeIdThree: this.$store.state.searchParams.makeIdProxy === 999999 ? 16360 : null, //Dacia
                        aMakeIdFour: this.$store.state.searchParams.makeIdProxy === 999999 ? 29 : null, // Ford
                        aMakeIdFive: this.$store.state.searchParams.makeIdProxy === 999999 ? 31 : null, // Honda
                        aMakeIdSix: this.$store.state.searchParams.makeIdProxy === 999999 ? 39 : null, // Kia
                        aMakeIdSeven: this.$store.state.searchParams.makeIdProxy === 999999 ? 46 : null, // Mazda
                        aMakeIdEight: this.$store.state.searchParams.makeIdProxy === 999999 ? 47 : null, // Mercedes
                        aMakeIdNine: this.$store.state.searchParams.makeIdProxy === 999999 ? 16338 : null, // Mini
                        aMakeIdTen: this.$store.state.searchParams.makeIdProxy === 999999 ? 54 : null, // Opel
                        aMakeIdEleven: this.$store.state.searchParams.makeIdProxy === 999999 ? 55 : null, // Peugeot
                        aMakeIdTwelve: this.$store.state.searchParams.makeIdProxy === 999999 ? 57 : null, // Porsche
                        aMakeIdThirteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 70 : null, // Toyota
                        aMakeIdFourteen: this.$store.state.searchParams.makeIdProxy === 999999 ? 73 : null // Volvo
                    }
                },
                error(error) {
                    // console.log('Car of the week might not be available anymore.')
                    // console.log({error})
                    if(parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    // console.log(data.loading);
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        this.qualifiedSearchFieldValuesObj = this.buildQualifiedSearchFieldValuesObj(data.data.qualifiedSearchFieldValues.listings.listings)
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/style.scss";
    @import "../styles/partials/_search-form";
</style>